import { render, staticRenderFns } from "./Libraries.vue?vue&type=template&id=510f0e96"
import script from "./Libraries.vue?vue&type=script&lang=js"
export * from "./Libraries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports